import React from 'react'
import classses from "./SubsExpiredBanner.module.css";
import { useSelector } from "react-redux"
const SubscriptionExpiredBanner = () => {
    const { accessToken } = useSelector(state => state?.authReducer)
    const { subscriptionExpired } = useSelector(state => state?.subscriptionExpiredReducer);
    console.log("SubscriptionExpired", subscriptionExpired)

    const showBanner = !!accessToken && subscriptionExpired

    return (
        <>
            {showBanner ? <div className={classses.wrapper}>

                <h2>Your subscription has expired. Please subscribe to get full access.</h2>
            </div> : null}
        </>
    )
}

export default SubscriptionExpiredBanner